import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PortalClinica from './pages/PortalClinica';
import EnvironmentBanner from './components/EnvironmentBanner';
import './App.css';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <EnvironmentBanner />
      <Router>
        <Routes>
          <Route path="/" element={<PortalClinica />} />
          <Route path="/definir-senha" element={<PortalClinica />} />
          <Route path="/:token" element={<PortalClinica />} />
          <Route path="/upload/:token" element={<PortalClinica />} />
          <Route path="/clinica/:token" element={<PortalClinica />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
